export default function compareSemver(version = '', compareTo = '') {
  const currentVersion = version.split('-')[0].split('.');
  const compareToVersion = compareTo.split('.');

  if (currentVersion.length !== 3 || compareToVersion.length !== 3) {
    return;
  }

  if (parseInt(currentVersion[0]) < parseInt(compareToVersion[0])) {
    return -1;
  } else if (parseInt(currentVersion[0]) > parseInt(compareToVersion[0])) {
    return 1;
  } else if (parseInt(currentVersion[1]) < parseInt(compareToVersion[1])) {
    return -1;
  } else if (parseInt(currentVersion[1]) > parseInt(compareToVersion[1])) {
    return 1;
  } else if (parseInt(currentVersion[2]) < parseInt(compareToVersion[2])) {
    return -1;
  } else if (parseInt(currentVersion[2]) > parseInt(compareToVersion[2])) {
    return 1;
  }

  return 0;
}

export const isCurrentVersionAtLeast = (version, compareTo) =>
  compareSemver(version, compareTo) >= 0;
